import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const AdminApi = createApi({
    reducerPath: "AdminApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_URL}/api/admin/`,
    }),
    tagTypes: ["SingleAdminData"],
    endpoints: (builder) => ({
        getSingleAdminData: builder.query({
            query: (email) => `/by/email/view/${email}`,
            providesTags: (results, error) => [
                { type: "SingleAdminData", results, error, id: "LIST" },
            ],
        }),

    }),
});
 
export const {
    useGetSingleAdminDataQuery,
} = AdminApi;
